"use strict";

exports.__esModule = true;
exports.AlertSubscription = AlertSubscription;
var _react = _interopRequireDefault(require("react"));
var _RealtimeConnection = require("../../API/RealtimeConnection");
var _excluded = ["type", "entity", "topicArgs"],
  _excluded2 = ["plant", "tenant"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function AlertSubscription(_ref) {
  var type = _ref.type,
    entity = _ref.entity,
    topicArgs = _ref.topicArgs,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_RealtimeConnection.RealtimeDataSubscription, _extends({
    params: ["alert", Object.assign({
      entity: Object.assign({}, entity, {
        name: type
      })
    }, topicArgs)],
    normalize: normalizeAlertValue
  }, extra));
}
function normalizeAlertValue(doc) {
  if (doc == null) {
    return null;
  }
  var _doc$entity = doc.entity,
    _plant = _doc$entity.plant,
    _tenant = _doc$entity.tenant,
    entity = _objectWithoutPropertiesLoose(_doc$entity, _excluded2);
  var description = doc.description;
  if (Object.keys(description).length === 0) {
    return null;
  }
  return Object.assign({}, entity, {
    type: doc.type,
    value: description,
    timestamp: Date.parse(doc.timestamp),
    timezone: doc.timezone
  });
}